import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api';
import { useAuth } from '@/features/auth/hooks/use-auth';

/*
  El nombre de cada empresa, ya pedido, por su id: se pide una vez por carga y
  no en cada pestaña de Mi empresa. Por id y no uno solo, porque la misma
  pestaña del navegador puede pasar de una empresa a otra (el portal).
*/
const nombres = new Map<string, string>();

/**
 * El nombre de la empresa de la sesión, para la píldora «Mi empresa · Datec».
 *
 * La sesión guardada no siempre lo trae: el usuario que deja el inicio de
 * sesión no incluye la empresa, sólo su id (sí la trae `/me`). Si falta, se pide
 * a `/api/tenant`, el mismo de la tarjeta de la empresa en Configuración. Si no
 * se puede, la píldora dice sólo «Mi empresa».
 */
export function useNombreDeLaEmpresa(): string | undefined {
  const { user } = useAuth();
  const id = user?.tenantId;
  const deLaSesion = user?.tenant?.name;
  const [pedido, setPedido] = useState<string | undefined>(id ? nombres.get(id) : undefined);

  useEffect(() => {
    if (!id || deLaSesion) return;
    const guardado = nombres.get(id);
    if (guardado) {
      setPedido(guardado);
      return;
    }
    let vigente = true;
    apiClient
      .get<{ name?: string }>('/api/tenant')
      .then((empresa) => {
        if (!empresa?.name) return;
        nombres.set(id, empresa.name);
        if (vigente) setPedido(empresa.name);
      })
      .catch(() => {});
    return () => {
      vigente = false;
    };
  }, [id, deLaSesion]);

  return deLaSesion ?? pedido;
}
